(function() {
    'use strict';

    angular.module('order').controller('AllegroThreadDetailsController', AllegroThreadDetailsController);

    AllegroThreadDetailsController.$inject = [
        '$state',
        'allegroThreadsDataSrvc',
        'allegroThreadMessagesConst',
        'allegroThreadPermissionsConst',
        'checkModelPermissionsSrvc',
        'notificationSrvc',
        'errorNotificationSrvc'
    ];

    function AllegroThreadDetailsController(
        $state, allegroThreadsDataSrvc, allegroThreadMessagesConst, allegroThreadPermissionsConst,
        checkModelPermissionsSrvc, notificationSrvc, errorNotificationSrvc
    ) {
        var self = this;
        self.loading = false;
        self.submitingForm = false;

        self.account = {};
        self.thread = {};
        self.messageData = {
            text: null,
            upload_files: null
        }
        self.serverErrors = {
            text: [],
            upload_files: []
        };

        self.getThread = getThread;
        self.sendThreadMessage = sendThreadMessage;
        self.hasPermissionSendThreadMessage = hasPermissionSendThreadMessage;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getThread();
        }

        function getThread() {
            self.loading = true;

            return allegroThreadsDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function (response) {
                    self.account = response.account;
                    self.thread = response;
                    return response;
                }
            ).finally(
                function (response) {
                    self.loading = false;
                }
            );
        }

        function hasPermissionSendThreadMessage() {
            return !checkModelPermissionsSrvc.isDenied(allegroThreadPermissionsConst.add);
        }

        function sendThreadMessage() {
            self.submitingForm = true;

            allegroThreadsDataSrvc.createMessage({pk: $state.params.pk}, self.messageData).$promise
            .then(function(response) {
                self.messageData.text = null;
                self.messageData.upload_files = [];

                self.thread.messages.push(response)
                notificationSrvc.notification("success", allegroThreadMessagesConst.add);
            })
            .catch(function (response) {
                errorNotificationSrvc.displayErrors(response.data);
                self.serverErrors = response.data;
            })
            .finally(function () {
                self.submitingForm = false;
            });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
